import { render } from "./level_3.svg?vue&type=template&id=9cfc1e5e"
const script = {}
script.render = render

export default script